import { useMutation } from 'react-query';

import { removeVersion as mutationFn } from 'api/endPoints/removeVersion';

export const useMutationRemoveXerFile = () => {
    return useMutation<any, QueryError, RemoveXerVersion>({ mutationFn: (params) => mutationFn(params) });
};

interface RemoveXerVersion {
    ids: number[];
}
